/**
 * Traduction des refus back sur l'envoi d'une réponse dans le chat.
 *
 * Sans ça l'échec est muet : le thunk rejette, la réponse n'part jamais et le modérateur n'a
 * aucun retour (constaté sur une réponse privée à un message staff, que le back refuse toujours).
 */

const PRIVATE_RECIPIENT_MUST_BE_ATTENDEE =
  'HTTP.ERROR.400.PRIVATE_MESSAGE.RECIPIENT_MUST_BE_ATTENDEE';
const PRIVATE_RECIPIENT_OFFLINE = 'HTTP.ERROR.400.PRIVATE_MESSAGE.RECIPIENT_OFFLINE';

export type ChatReplyErrorKey =
  | 'privateReplyStaffError'
  | 'privateReplyOfflineError'
  | 'replyError';

/**
 * Le code métier vit soit à la racine, soit dans `details` quand le back agrège plusieurs
 * erreurs de validation (la racine vaut alors HTTP.ERROR.400.VALIDATION.ERRORS).
 */
export function collectApiErrorCodes(error: unknown): string[] {
  if (error == null || typeof error !== 'object') return [];
  const err = error as { message?: unknown; details?: unknown };
  const codes: string[] = [];
  if (typeof err.message === 'string') codes.push(err.message);
  if (Array.isArray(err.details)) {
    for (const detail of err.details) {
      const message = (detail as { message?: unknown } | null)?.message;
      if (typeof message === 'string') codes.push(message);
    }
  }
  return codes;
}

/** Clé i18n (relative à `live.chat` / `adminLive.chat`) à afficher pour un envoi de réponse refusé. */
export function resolveReplyErrorKey(error: unknown): ChatReplyErrorKey {
  const codes = collectApiErrorCodes(error);
  if (codes.includes(PRIVATE_RECIPIENT_MUST_BE_ATTENDEE)) return 'privateReplyStaffError';
  if (codes.includes(PRIVATE_RECIPIENT_OFFLINE)) return 'privateReplyOfflineError';
  return 'replyError';
}
